import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages, Check } from 'lucide-react';
import { Dropdown, DropdownItem } from './design-system';
import { SUPPORTED_LANGUAGES } from '../i18n/config';

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
  };

  const currentLanguage = SUPPORTED_LANGUAGES.find(
    (lang) => lang.code === i18n.language
  ) || SUPPORTED_LANGUAGES[0];

  return (
    <Dropdown
      trigger={
        <button
          className="flex items-center gap-2 p-2 hover:bg-gray-100 rounded-lg transition-colors"
          aria-label={t('language.selectLanguage')}
        >
          <Languages className="h-5 w-5 text-gray-600" />
          <span className="hidden sm:block text-sm font-medium text-gray-700">
            {currentLanguage.nativeName}
          </span>
        </button>
      }
      align="right"
    >
      <div className="px-4 py-2 border-b border-gray-200">
        <p className="text-xs font-medium text-gray-500 uppercase">
          {t('language.selectLanguage')}
        </p>
      </div>
      
      {SUPPORTED_LANGUAGES.map((language) => (
        <DropdownItem
          key={language.code}
          onClick={() => changeLanguage(language.code)}
          icon={
            i18n.language === language.code ? (
              <Check className="h-4 w-4 text-primary-600" />
            ) : (
              <div className="h-4 w-4" />
            )
          }
        >
          <div className="flex items-center justify-between gap-4">
            <span>{language.nativeName}</span>
            {i18n.language === language.code && (
              <span className="text-xs text-primary-600 font-medium">
                {t('language.english') === language.name ? '✓' : ''}
              </span>
            )}
          </div>
        </DropdownItem>
      ))}
    </Dropdown>
  );
};
